import { Navigate, Outlet } from 'react-router-dom';
import { USER_ROUTES } from '../routes.const';
import AuthorizedRoute from '../AuthorizedRoute';
import FullLayout from '../../Layouts/FullLayout';
import { lazy, Suspense } from 'react';
import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { ModuleProjectProvider } from 'common/contexts/useModuleProjectContext';

const SettingsPage = lazy(() => import('../../modules/user/pages/MyProfilePage'));
const FilesPath = lazy(() => import('../../modules/user/pages/MyFilesPage'));

const UserPage = () => {
  const { compareUrl } = useCompareUrlWithProjectId();

  if (compareUrl(USER_ROUTES.root, { endsWith: true })) {
    return <Navigate to={`${USER_ROUTES.settings}`} replace={true} />;
  }

  return (
    <FullLayout>
      <Suspense>
        <Outlet />
      </Suspense>
    </FullLayout>
  );
};

export const userRoutes = [
  {
    path: USER_ROUTES.root,
    element: (
      <ModuleProjectProvider>
        <AuthorizedRoute>
          <UserPage />
        </AuthorizedRoute>
      </ModuleProjectProvider>
    ),
    children: [
      {
        path: `${USER_ROUTES.settings}`,
        element: <SettingsPage />,
      },
      {
        path: `${USER_ROUTES.files}`,
        element: <FilesPath />,
      },
    ],
  },
];
